<template>
    <div id="vipExclusive">
        <Headers :headersText='headersText'></Headers>
        <!-- 说明 -->
        <div class="explain">
            <div>* 微信专属关键词 试货网</div>
            <div>* 点击进入识货网微信公众号，进行关注。</div>
            <div>用户在试货网注册账号后，即刻到试货网新手必中</div>
            <div>专区中免费领取礼品，领取过程中如有疑问，可直接联系试货网客服。</div>
            <div>* 试货网官网地址：www.shihuowang.com</div>
        </div>
    </div>
</template>

<script>
    import Headers from '../components/headers'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'会员专属福利',
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #vipExclusive{
        .explain{
            width:316px;
            height:181px;
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:22px;
            padding: 29px 33px 15px 26px;
        }
    }
</style>